import React from 'react';
import { motion } from 'framer-motion';
import { CONSTANTS } from '../data.js';
import { iconFor } from '../lib/utils';
import type { Instance } from '../types';

type ElementInstanceProps = {
  inst: Instance;
  isHighlighted: boolean;
  isDragging: boolean;
  onPointerDown: (e: React.PointerEvent, id: number) => void;
};

export const ElementInstance: React.FC<ElementInstanceProps> = ({ inst, isHighlighted, isDragging, onPointerDown }) => {
  const el = CONSTANTS.elements[inst.elementKey];
  const label = el ? el.name : inst.elementKey;

  return (
    <motion.div
      key={inst.id}
      layout={!isDragging}
      transition={{
        type: 'spring',
        stiffness: isDragging ? 800 : 500,
        damping: isDragging ? 40 : 30,
        mass: isDragging ? 0.5 : 1
      }}
      className={`absolute select-none cursor-grab active:cursor-grabbing ${isHighlighted ? 'z-20' : 'z-10'} ${isDragging ? 'z-30' : ''}`}
      style={{ left: inst.x, top: inst.y }}
      onPointerDown={(e) => onPointerDown(e, inst.id)}
      data-tutorial-target={inst.elementKey === 'stone' ? 'board_stone' : undefined}
    >
      <div
        className={`w-16 h-16 rounded-lg border bg-white/5 backdrop-blur relative transition-all duration-150 ${
          isHighlighted
            ? 'border-yellow-300 shadow-[0_0_18px_rgba(253,224,71,0.8)] scale-[1.06]'
            : isDragging
            ? 'border-blue-300 shadow-[0_0_12px_rgba(59,130,246,0.6)] scale-[1.03]'
            : 'border-white/10 shadow-lg hover:border-white/20 hover:shadow-xl'
        }`}
      >
        <img
          src={iconFor(inst.elementKey)}
          alt={label}
          className="w-full h-full object-contain p-1.5"
          draggable={false}
        />
        {isDragging && (
          <div className="absolute inset-0 rounded-lg bg-blue-400/20 animate-pulse" />
        )}
      </div>
      <div className={`text-[11px] text-center mt-1 drop-shadow transition-colors ${
        isDragging ? 'text-blue-200' : 'text-white/90'
      }`}>
        {label}
      </div>
    </motion.div>
  );
};
